export const environment = {
  production: false,
  environment: 'dev',
  services: {
    taxDocNotifierApi: "https://devapi.rwbaird.com/TaxDocNotifierApi/v1",
    configVault: 'https://devconfigvaultservice.es.rwbaird.com/configvaultservice/v1'
  },
  clientId: '7a91a73f-9c63-4567-aceb-35f8287f124c',    // taxdocnotifier-dev
  tenantName: 'b3ce298e-fe66-4a55-8590-71fa0a3e469c',
  jwtConfig: {
    appName: 'TaxDocNotifier',
    issuerIdentifier: 'TaxDocNotifierJWTIssuer',
    checkNestedAdGroups: false
  },
  appInsights: {
    instrumentationKey: null //'9ab9ceea-47df-4b54-a288-03351ed1402e'
  },
  detailsPageSize: 3
};